import Api from '@/api'

const state = {
    maxGroupNum: 2000
}
const getters = {
    maxGroupNum: state => state.maxGroupNum
}
const mutations = {}
const actions = {
    async loadSetting({state}, params) {
        let {data} = await Api.settinginfo(params);
        state.maxGroupNum = data;
    },
    async settingupdate({state}, params) {
        let {data} = await Api.settingupdate(params);
        state.maxGroupNum = data;
    }
}
export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/components/setting_store.js